import webinar from "../services/webinar";
import { $subscriber, cr } from "fire-wind-water";
import { tenantId } from "@/common/sbase";

window.addEventListener("message", ev => {
  if (false === cr.isUndefined(ev.data.settingUrl))
    $subscriber.emit("loadConfig", [ev.data]);
});
export const mixinsTemplate = {
  data() {
    return {
      template: {
        meeting: null,
        meetingInfo: null,
        isLoading: false,
        isloaded: false
      },
      pctemplate: {
        meeting: null
      },
      tenantPermInfo: {
        isDisabledVoteQueDown: 2,
        isDisabledRedPacket: 2,
        isDisabledLuckDraw: 2,
        isDisabledInteract: 2
      }
    };
  },
  created() {
    //首次加载config
    $subscriber.subscribe("webinarInfo", webinarInfo => {
      let isMobile = !!navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|HarmonyOS|OpenHarmony)/i
      );
      let dataConfigId = isMobile
        ? webinarInfo.wapConfigId
        : webinarInfo.pcConfigId;
      if (dataConfigId) {
        if (this.template.isLoading) return;
        this.template.isLoading = true;
        webinar
          .getConfig({
            tenantId: tenantId,
            configId: isMobile
              ? webinarInfo.wapConfigId
              : webinarInfo.pcConfigId // webinarInfo.pcConfigId >0?1032091:0
          })
          .subscribe(res => {
            $subscriber.emit("loadConfig", [
              res.content.configInfo.html[0],
              res.content.configInfo.html[1]
            ]);
          });
        if (isMobile) {
          webinar
            .getConfig({
              tenantId: tenantId,
              configId: webinarInfo.pcConfigId
            })
            .subscribe(res => {
              $subscriber.emit("pcloadConfig", [
                res.content.configInfo.html[0],
                res.content.configInfo.html[1]
              ]);
            });
        }
      }
    });
    //function convertArrayToObject(array, key) {
    //  const initialValue = {};
    //  return array.reduce((obj, item) => {
    //    return {
    //      ...obj,
    //      [item[key]]: item
    //    };
    //  }, initialValue);
    //}
    //订阅config的变化
    $subscriber.subscribe("loadConfig", configs => {
      this.setConfig(configs, "template");
      //if (cr.isUndefined(configs)) {
      //  window.$sk.alert("数据加载错误，网络异常");
      //  return;
      //}
      ////只处理v3多层级模板
      //cr.each(configs, config => {
      //  let extras = [];
      //  let extra2Array = function(array, targetArray) {
      //    cr.each(array, function(d) {
      //      if (d.type === "element") {
      //        targetArray.push(d);
      //      } else {
      //        extra2Array(d.extras, targetArray);
      //      }
      //    });
      //  };
      //  extra2Array(config.extra, extras); //将有用的extra 递归便利到数组中
      //  let result = convertArrayToObject(extras, "attrName"); //改成key-object形式 方便调用
      //  //处理postmessage传来的数据与getconfig接口返回的数据格式不一致问题
      //  cr.each(result, item => {
      //    if (false === cr.isUndefined(item.display)) {
      //      if (
      //        item.display.defaultValue === "1" ||
      //        item.display.defaultValue === "true"
      //      )
      //        item.display.defaultValue = true;
      //      if (
      //        item.display.defaultValue === "0" ||
      //        item.display.defaultValue === "false"
      //      )
      //        item.display.defaultValue = false;
      //      if (item.display.value === "1" || item.display.value === "true")
      //        item.display.value = true;
      //      if (item.display.value === "0" || item.display.value === "false")
      //        item.display.value = false;
      //    }
      //  });
      //  this.$set(this.template, config.name, result);
      //});
      this.template.isloaded = true;
    });
    //订阅pcconfig的变化
    $subscriber.subscribe("pcloadConfig", configs => {
      this.setConfig(configs, "pctemplate");
    });
    //互动参数设置
    $subscriber.subscribe("tenantPermInfo", permInfo => {
      this.tenantPermInfo = permInfo;
    });
  },
  methods: {
    convertArrayToObject(array, key) {
      const initialValue = {};
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item
        };
      }, initialValue);
    },
    setConfig(configs, templateName) {
      if (cr.isUndefined(configs)) {
        window.$sk.alert("数据加载错误，网络异常");
        return;
      }
      //只处理v3多层级模板
      cr.each(configs, config => {
        let extras = [];
        let extra2Array = function(array, targetArray) {
          cr.each(array, function(d) {
            if (d.type === "element") {
              targetArray.push(d);
            } else {
              extra2Array(d.extras, targetArray);
            }
          });
        };
        extra2Array(config.extra, extras); //将有用的extra 递归便利到数组中
        let result = this.convertArrayToObject(extras, "attrName"); //改成key-object形式 方便调用
        //处理postmessage传来的数据与getconfig接口返回的数据格式不一致问题
        cr.each(result, item => {
          if (false === cr.isUndefined(item.display)) {
            if (
              item.display.defaultValue === "1" ||
              item.display.defaultValue === "true"
            )
              item.display.defaultValue = true;
            if (
              item.display.defaultValue === "0" ||
              item.display.defaultValue === "false"
            )
              item.display.defaultValue = false;
            if (item.display.value === "1" || item.display.value === "true")
              item.display.value = true;
            if (item.display.value === "0" || item.display.value === "false")
              item.display.value = false;
          }
        });
        this.$set(this[templateName], config.name, result);
      });
    }
  }
};
